<template>
    <div style="width:100%; box-sizing: border-box; text-align: left;">
        <GrcDB ref="GRCDB"></GrcDB>    
        <GrcDialog ref="Dialog"
            v-on:popupopened="SetPopupRef('Dialog')"
            v-on:popupclosed="SetPopupRef('')"
        ></GrcDialog>


        <div style="width:100%; box-sizing:border-box; max-width:500px; margin:0px auto; display:block; border: solid 1px #ccc; padding: 8px; background-color: #f4f5f6;"
        v-show="innerformid==1">

            <div class="infotext" style="text-align:center;" v-html="FizetesText" />

            <table style="width:100%; margin-top:20px; margin-bottom:20px;" cellspacing="0" cellpadding="0" v-show="GetLinkData_IntResult==1">
            <tr>
                <td style="width:45px; padding-top:2px;" valign="top"><GrcCheckboxMobile ref="chkFelhFelt" /></td>
                <td valign="top" style="text-align:left; font-family:'CmsDefault'; font-size:16px; line-height:24px; color:#222; padding-top:0px;">
                    A <span @click="ShowFelt()" style="color:dodgerblue; cursor:pointer;"><u>biztosítási feltételek</u></span> vonatkozó pontjait és az 
                    <span @click="ShowSimpleNyilatkozat()" style="color:dodgerblue; cursor:pointer;"><u>adattovábbítási nyilatkozatot</u></span> megismertem és elfogadom. 
                </td>
            </tr>
            </table>         


            <div style="width:100%; box-sizing:border-box; text-align:center;" v-show="GetLinkData_IntResult==1">

                <span @click="btnStartPreparePayment_click" class="painted_linkbutton2 color3" style="margin: 4px 8px;">
                    <span>Tovább a bankkártyás fizetéshez<i class="fal fa-chevron-right" style="margin-left: 4px;"></i></span>
                </span>        

            </div>

        </div>



        <div style="width:100%; box-sizing:border-box; max-width:500px; margin:0px auto; display:block;" v-show="innerformid==2">

            <div class="infotext" v-html="BefizResultInfoText" />

            <div class="btn_cont" style="margin-top:20px; text-align:left;" v-show="BefizLink!=''">

                <span @click="btnRetry_click" class="painted_linkbutton2 color3" style="margin: 4px 8px;">
                    <span>Újra próbálom<i class="fal fa-chevron-right" style="margin-left: 4px;"></i></span>
                </span>                                        

            </div>

            <div class="btn_cont" style="margin-top:20px; text-align:left;" v-show="BefizLink==''">

                <span @click="btnRetry_click" class="painted_linkbutton2 color3" style="margin: 4px 8px;">
                    <span>Tovább az igénylésekhez<i class="fal fa-chevron-right" style="margin-left: 4px;"></i></span>
                </span>                                        

            </div>

        </div>

    </div>
</template>

<script>

import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'
import GrcCheckboxMobile from '../GrcComponents/GrcCheckboxMobile.vue'

export default {
  name: 'frmonreszbefizetes_atiranyitassal',
  components: {
      GrcDB,
      GrcDialog,
      GrcCheckboxMobile,
  },
  props: {
  },
  data () {
      return {
            WSPREFIX: "frmOnreszBefizetes",
            gPopupControlName:"",

            innerformid:0,
            Azonosito:"",
            BefizResultInfoText:"",
            feltetel:"",
            FizetesText:"",
            GetLinkData_IntResult:0,
            Simple_Adattovabbitas:"",


            OFSZ_ID:0,
            BefizLink:"",
            PortalLink:"",

            FeltTextbookItem:"",
            
      }
  },
  model: {
  },  
  methods:{

    SetPopupRef(pRef)
    {
        gPopupControlName = pRef;
    },

    scrollToTop() { window.scrollTo(0,0); },

    GetTextBookItem(pCompName)
    {
        return grcmain_GetTextBookItem("frmOnreszBefizetes", pCompName);
    },

    SetControlToFocus(pNextComp)
    {
        if (pNextComp == "") { return; }

        this.$refs[pNextComp].SetFocus();
    },


    SetLang()
    {
        this.Init();
    },


    btnRetry_click()
    {
        document.location = this.BefizLink;
    },

    btnIgenyek_click()
    {
        document.location = this.PortalLink;
    },

    async ShowSimpleNyilatkozat()
    {
        var DialogResult = "";
        var p = grccomp_dialog_alert_GetDefaults("Adattovábbítási nyilatkozat", this.Simple_Adattovabbitas);             
        p.height = 450;
        p.width = 500;
        p.padding_top = 20;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }
        await this.$refs.Dialog.ShowDialog(p).then(res => 
        { 
            DialogResult = res; 
        });               

    },

    async ShowFelt()
    {
        var DialogResult = "";
        var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), this.feltetel);             
        p.height = 800;
        p.width = 600;
        p.padding_top = 20;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }
        await this.$refs.Dialog.ShowDialog(p).then(res => 
        { 
            DialogResult = res; 
        });               

    },

    async btnStartPreparePayment_click()
    {

        if (this.$refs.chkFelhFelt.GetValue() == 0)
        {
            await this.ShowInfoDialog("A felhasználási feltételek és nyilatkozatok elfogadása kötelező!", 200);
            return;
        }

        this.PreparePayment_Dialog_Atiranyitassal();
    },


async PreparePayment_Dialog_Atiranyitassal()
{
    this.$refs.GRCDB.ShowLoading(false);

    var QP = {
        sAzonosito: this.Azonosito
    };
    var Q;
    await this.$refs.GRCDB.GetData(this.WSPREFIX+"_PreparePayment_Atiranyitassal", QP).then(res => { Q = res; });

    if (Q.APPERR[0].ERR != "")
    {
        this.$refs.GRCDB.HideLoading();
        await this.ShowInfoDialog(Q.APPERR[0].ERR, 250);
        return;
    }


    //console.log(Q.PAYMENT);

    this.$refs.GRCDB.HideLoading();

    if (Q.PAYMENT[0].intResult != 1)
    {
        alert(Q.PAYMENT[0].strResult);
        return;
    }

    let OrderNumber = Q.PAYMENT[0].ORDER_REF;

        var SIMPLE_LIVEUPDATE_URL = Q.PAYMENT[0].SIMPLE_LIVEUPDATE_URL;
        var TIMEOUT_URL = Q.PAYMENT[0].PAYCENTER_TIMEOUT;
        var BACK_REF = Q.PAYMENT[0].PAYCENTER_BACKREF;

        var myForm = document.createElement("form");
        myForm.method = "post";
        myForm.action = SIMPLE_LIVEUPDATE_URL;
        var myInput;

        myInput = document.createElement("input");
        myInput.setAttribute("name", "MERCHANT");
        myInput.setAttribute("id", "MERCHANT");
        myInput.setAttribute("value", Q.PAYMENT[0].MERCHANT);
        myForm.appendChild(myInput);


        myInput = document.createElement("input");
        myInput.setAttribute("name", "ORDER_REF");
        myInput.setAttribute("id", "ORDER_REF");
        myInput.setAttribute("value", Q.PAYMENT[0].ORDER_REF);
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "ORDER_DATE");
        myInput.setAttribute("id", "ORDER_DATE");
        myInput.setAttribute("value", Q.PAYMENT[0].ORDER_DATE);
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "ORDER_PNAME[]");
        myInput.setAttribute("id", "ORDER_PNAME");
        myInput.setAttribute("value", Q.PAYMENT[0].ORDER_PNAME);
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "ORDER_PCODE[]");
        myInput.setAttribute("id", "ORDER_PCODE");
        myInput.setAttribute("value", Q.PAYMENT[0].ORDER_PCODE);
        myForm.appendChild(myInput);


        myInput = document.createElement("input");
        myInput.setAttribute("name", "ORDER_PRICE[]");
        myInput.setAttribute("id", "ORDER_PRICE");
        myInput.setAttribute("value", Q.PAYMENT[0].ORDER_PRICE);
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "ORDER_VAT[]");
        myInput.setAttribute("id", "ORDER_VAT");
        myInput.setAttribute("value", Q.PAYMENT[0].ORDER_VAT);
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "ORDER_QTY[]");
        myInput.setAttribute("id", "ORDER_QTY");
        myInput.setAttribute("value", Q.PAYMENT[0].ORDER_QTY);
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "PRICES_CURRENCY");
        myInput.setAttribute("id", "PRICES_CURRENCY");
        myInput.setAttribute("value", "HUF");
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "TIMEOUT_URL");
        myInput.setAttribute("id", "TIMEOUT_URL");
        myInput.setAttribute("value", TIMEOUT_URL);
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "BACK_REF");
        myInput.setAttribute("id", "BACK_REF");
        myInput.setAttribute("value", BACK_REF);
        myForm.appendChild(myInput);


        myInput = document.createElement("input");
        myInput.setAttribute("name", "BILL_EMAIL");
        myInput.setAttribute("id", "BILL_EMAIL");
        myInput.setAttribute("value", Q.PAYMENT[0].BILL_EMAIL);
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "ORDER_HASH");
        myInput.setAttribute("id", "ORDER_HASH");
        myInput.setAttribute("value", Q.PAYMENT[0].ORDER_HASH);
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "PAY_METHOD");
        myInput.setAttribute("id", "PAY_METHOD");
        myInput.setAttribute("value", "CCVISAMC");
        myForm.appendChild(myInput);

        if (Q.PAYMENT[0].LU_ENABLE_TOKEN == "1")
        {
            myInput = document.createElement("input");
            myInput.setAttribute("name", "LU_ENABLE_TOKEN");
            myInput.setAttribute("id", "LU_ENABLE_TOKEN");
            myInput.setAttribute("value", Q.PAYMENT[0].LU_ENABLE_TOKEN);
            myForm.appendChild(myInput);

            myInput = document.createElement("input");
            myInput.setAttribute("name", "LU_TOKEN_TYPE");
            myInput.setAttribute("id", "LU_TOKEN_TYPE");
            myInput.setAttribute("value", Q.PAYMENT[0].LU_TOKEN_TYPE);
            myForm.appendChild(myInput);
        }


        document.body.appendChild(myForm);
        myForm.submit();
        document.body.removeChild(myForm);        


  
  
},




    async Init()
    {
        this.Azonosito = "";

        if (GRCAPP_GetParameters.hasOwnProperty("LNKAZON"))
        {
          this.Azonosito = GRCAPP_GetParameters.LNKAZON;
        }

        this.$refs.GRCDB.ShowLoading(false);
        
        var QP = {
            sAzonosito: this.Azonosito
        };
        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX+"_Init", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            this.ShowInfoDialog(Q.APPERR[0].ERR, 200);
            return;
        }

        this.FizetesText = Q.RESULT[0].FizetesText;
        this.GetLinkData_IntResult = Q.RESULT[0].intResult;
        this.Simple_Adattovabbitas = Q.RESULT[0].Simple_Adattovabbitas;

        this.FeltTextbookItem = Q.RESULT[0].FeltTextbookItem;

        this.feltetel = this.GetTextBookItem(this.FeltTextbookItem);




        this.innerformid = 1;
        
        this.$refs.GRCDB.HideLoading();
        
    },


    async ShowInfoDialog(pText, pHeight)
    {
        var DialogResult = "";
        var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), pText);             
        p.height = pHeight;
        p.width = 400;
        p.padding_top = -1;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }
        await this.$refs.Dialog.ShowDialog(p).then(res => 
        { 
            DialogResult = res; 
        });               
    },



  },

  created()
  {

  },

  mounted()
  {
    gForm = this;
    gPopupControlName = "";

    if (gAppInitDone)
    {
      this.SetLang();
    }
  }

}


</script>


<style scoped>

.maintitle
{
    width: 100%;
    box-sizing: border-box;
    color:#fff;
    font-family: "CmsDefault";
    font-size:22px;
    line-height: 22px;
    font-weight:normal;
    text-align: left;
    padding: 10px;
}

.main_col_cont
{
    width:100%;
    box-sizing: border-box;
    direction: rtl;
}

.main_col
{
    width:50%;
    box-sizing: border-box;
    display:inline-block;
    vertical-align: top;
    direction: ltr;
}

.innerform
{
    width:100%;
    box-sizing: border-box;
}

.infotext
{
    width: 100%;
    box-sizing: border-box;
    color: #323232;
    font-family: "CmsDefault";
    font-size:16px;
    line-height: 22px;
    font-weight:normal;
    text-align: justify;
    padding: 0px;
}

div >>> .info_title
{
    width: 100%;
    box-sizing: border-box;
    color: var(--premblue);
    font-family: "CmsDefault";
    font-size:18px;
    line-height: 22px;
    font-weight:normal;
    text-align: left;
    padding: 10px 0px;
    font-weight: 500;
}


.btn_cont
{
  width:100%;
  box-sizing: border-box;
  padding:4px 0px;
  border-top:solid 0px #ccc;
  margin-top: 0px;
  text-align: center;
}

.btn
{
  display: inline-block;
  font-size: 13px;
  line-height: 16px;
  font-family: 'CmsDefault';
  font-weight: normal;
  text-align: center;  
  background-color:var(--premblue);
  color:#fff;
  padding:8px 8px;
  cursor:pointer;
  border-radius: 2px;
  margin: 2px;
  min-width: 120px;
}

.btn_gray2
{
  background-color: #ccc;
  color:#222;
}

.btn:hover
{
  background-color: var(--premgreen);
  color:#fff;
}

.btn_icon
{
    margin-right:4px;
}

.btn_text
{
    display:inline;
}

.btn_gray
{
  background-color: #ccc;
  color:#fff;
  cursor: default;
  opacity: 0;
}

.btn_gray:hover
{
  background-color: #ccc;
  color:#fff;
  cursor: default;
  opacity: 0;
}

.simple_logo_link
{
    text-decoration: none;
}

.simple_link
{
    color:dodgerblue;
    text-decoration: underline;
}

.simple_link:visited
{
    color:dodgerblue;
    text-decoration: underline;
}

.simple_link:hover
{
    color:dodgerblue;
    text-decoration: underline;
}



.simple_link2
{
    background-color: var(--premblue);
    color: #fff;
    font-size: 14px;
    line-height: 14px;
    display: inline-block;
    padding: 8px;
    text-decoration: none;
    border-radius: 2px;
    padding-top: 9px;
    margin: 1px;    
}

.simple_link2:hover
{
    background-color: var(--premgreen);
}

@media (max-width:900px)
{
    .infotext
    {
        font-size:14px;
        line-height: 18px;
    }

}

@media (max-width:700px)
{
    .main_col
    {
        width:100%;
    }

    .infotext
    {
        font-size:14px;
        line-height: 18px;
        padding: 10px 0px 20px 0px;
    }

    .btn_cont
    {
        text-align: center;
    }
}


</style>